import { BaseError } from './base';

export class FeeEstimationFailedError extends BaseError {
  constructor(params: { cause?: Error; message: string }) {
    super({
      cause: params.cause || null,
      code: 'fee_estimation_failed_error',
      docsUrl: null,
      name: 'FeeEstimationFailedError',
      shortMessage: params.message,
    });
  }
}
